import { httpClient } from "../../../shared/api/httpClient";
import type {
  LeadTimeBulkCreateResult,
  LeadTimeBulkDeleteResult,
  LeadTimeBulkUpdateResult,
  LeadTimeConfigurationInput,
  LeadTimeTargetPage,
  LeadTimeRuleTarget,
} from "../model/types";

export interface LeadTimeTargetQuery {
  page: number;
  page_size: number;
  search?: string;
}

export const fetchLeadTimeTargets = async (
  query: LeadTimeTargetQuery,
): Promise<LeadTimeTargetPage> => {
  const response = await httpClient.get<LeadTimeTargetPage>(
    "/lead-time-rules/targets",
    { params: query },
  );
  return response.data;
};

export const createLeadTimeTargets = async (
  customerCodes: string[],
  productCodes: string[],
  configuration: LeadTimeConfigurationInput,
): Promise<LeadTimeBulkCreateResult> => {
  const response = await httpClient.post<LeadTimeBulkCreateResult>(
    "/lead-time-rules/targets/bulk",
    {
      customer_codes: customerCodes,
      product_codes: productCodes,
      ...configuration,
    },
  );
  return response.data;
};

export const updateLeadTimeTarget = async (
  targetId: number,
  configuration: LeadTimeConfigurationInput,
): Promise<LeadTimeRuleTarget> => {
  const response = await httpClient.put<LeadTimeRuleTarget>(
    `/lead-time-rules/targets/${targetId}`,
    configuration,
  );
  return response.data;
};

export const deleteLeadTimeTarget = async (targetId: number): Promise<void> => {
  await httpClient.delete(`/lead-time-rules/targets/${targetId}`);
};

export const bulkUpdateLeadTimeTargets = async (
  targetIds: number[],
  configuration: LeadTimeConfigurationInput,
): Promise<LeadTimeBulkUpdateResult> => {
  const response = await httpClient.put<LeadTimeBulkUpdateResult>(
    "/lead-time-rules/targets/bulk",
    { target_ids: targetIds, ...configuration },
  );
  return response.data;
};

export const bulkDeleteLeadTimeTargets = async (
  targetIds: number[],
): Promise<LeadTimeBulkDeleteResult> => {
  const response = await httpClient.post<LeadTimeBulkDeleteResult>(
    "/lead-time-rules/targets/bulk-delete",
    { target_ids: targetIds },
  );
  return response.data;
};
